import apiClient from '../apiClient';

export const inviteEmployee = async (payload) => {
  const response = await apiClient.post('/employee-invitations', payload);
  return response?.data;
};

export const fetchPendingInvitations = async () => {
  const response = await apiClient.get('/employee-invitations');
  return response?.data;
};

export const fetchInvitationDetails = async (token) => {
  if (!token) {
    throw new Error('Missing invitation token');
  }
  const response = await apiClient.get(`/employee-invitations/${token}`);
  return response?.data;
};

export const revokeEmployeeInvitation = async (token) => {
  if (!token) {
    throw new Error('Missing invitation token');
  }
  const response = await apiClient.patch(
    `/employee-invitations/${token}/revoke`
  );
  return response?.data;
};

export const generateEmployeeId = async () => {
  const response = await apiClient.get(
    '/employee-invitations/generate-employee-id'
  );
  return response?.data;
};

export const completeEmployeeOnboarding = async (payload) => {
  const requestBody = payload ?? {};
  const isFormData =
    typeof FormData !== 'undefined' && payload instanceof FormData;

  const config = isFormData
    ? {
        headers: { 'Content-Type': 'multipart/form-data' },
        transformRequest: (data) => data,
      }
    : undefined;

  const response = await apiClient.post(
    '/auth/register',
    requestBody,
    config,
  );
  return response?.data;
};

export default {
  inviteEmployee,
  fetchPendingInvitations,
  fetchInvitationDetails,
  revokeEmployeeInvitation,
  generateEmployeeId,
  completeEmployeeOnboarding,
};
